/**
 * File: src/i18n/translations.js
 * Mô tả: Từ điển đa ngôn ngữ (English & Tiếng Việt) cho toàn bộ website SNT Games. Mặc định là Tiếng Anh.
 * Liên quan: src/i18n/i18n-service.js, src/components/header.js, src/pages/home-page.js
 */

export const translations = {
  en: {
    nav: {
      home: 'Home',
      games: 'Games',
      studio: 'About Studio',
      newsletter: 'Newsletter',
      admin: 'Admin Portal',
    },
    hero: {
      badge: '✨ Featured Game of 2026',
      title: 'Ant Clash',
      subtitle: 'A fast-paced 2D real-time strategy game where you command an ant colony to battle termites and conquer nests.',
      explore: '🔥 Explore Game',
      allGames: '🎮 All Games',
    },
    showcase: {
      badge: 'GAMES COLLECTION',
      title: 'Explore Our Featured Games',
      subtitle: 'Immerse yourself in rich worlds, deep strategy, and cutting-edge gaming experiences.',
      viewDetails: 'View Game Page',
    },
    gameDetail: {
      breadcrumbHome: 'Home',
      breadcrumbGames: 'Games',
      readWiki: '📖 Read Manual & Game Specs',
      screenshots: 'Screenshot Gallery',
    },
    about: {
      badge: 'ABOUT SNT GAMES',
      title: 'About SNT Games',
      story: 'SNT Games is an independent game studio based in Hanoi, Vietnam, founded in 2024. We build mobile strategy and board games, including chess and Xiangqi products, while developing shared technology and AI-assisted workflows that help a small team efficiently build, operate, and maintain multiple games.',
      founder: 'Founder',
      founded: 'Founded in',
      founderBio: 'Software and game developer focused on mobile strategy games, chess and Xiangqi products, and AI-assisted game development workflows.',
      statGames: 'Released Games',
      statPlayers: 'Active Players',
      statUptime: 'Server Uptime',
      statRating: 'Average Rating',
    },
    newsletter: {
      title: 'Stay Updated with SNT Games',
      subtitle: 'Subscribe to get early access, exclusive developer devlogs, and game release announcements.',
      placeholder: 'Enter your email address...',
      subscribe: 'Subscribe Now',
      success: '🎉 Thank you for subscribing! Check your inbox for confirmation.',
    },
    footer: {
      desc: 'Independent game studio building mobile strategy and board games, including chess and Xiangqi.',
      quickLinks: 'Quick Links',
      contact: 'Contact Us',
      rights: 'All rights reserved.',
    },
    admin: {
      title: '🔐 SNT Games Config Admin Portal',
      subtitle: 'Select a game to load, edit, and publish remote configs.',
      protected: '🛡️ Cloudflare Zero Trust Protected',
      loginTitle: 'Admin Portal Login',
      loginDesc: 'Please authenticate with your admin credentials.',
      username: 'Username',
      password: 'Password',
      remember: 'Remember session',
      loginBtn: '🔒 Login to Admin Portal',
      logoutBtn: '🔴 Logout',
    },
  },
  vi: {
    nav: {
      home: 'Trang Chủ',
      games: 'Trò Chơi',
      studio: 'Về Studio',
      newsletter: 'Tin Tức',
      admin: 'Cổng Admin',
    },
    hero: {
      badge: '✨ Game Nổi Bật 2026',
      title: 'Ant Clash',
      subtitle: 'Game chiến thuật thời gian thực 2D nhịp độ nhanh nơi bạn chỉ huy đàn kiến đối đầu với đàn mối để chiếm quyền kiểm soát các tổ.',
      explore: '🔥 Xem Chi Tiết Game',
      allGames: '🎮 Tất Cả Game',
    },
    showcase: {
      badge: 'BỘ SƯU TẬP GAME',
      title: 'Khám Phá Các Tựa Game Đỉnh Cao',
      subtitle: 'Hòa mình vào thế giới phong phú, chiến thuật sâu sắc và trải nghiệm chơi game tiên tiến.',
      viewDetails: 'Xem Trang Game',
    },
    gameDetail: {
      breadcrumbHome: 'Trang Chủ',
      breadcrumbGames: 'Games',
      readWiki: '📖 Đọc Hướng Dẫn & Chỉ Số Game',
      screenshots: 'Thư Viện Ảnh Screenshots',
    },
    about: {
      badge: 'VỀ SNT GAMES',
      title: 'Về SNT Games',
      story: 'SNT Games là studio game độc lập tại Hà Nội, Việt Nam, được thành lập năm 2024. Chúng tôi phát triển game chiến thuật trên di động và các trò chơi bàn cờ, bao gồm cờ vua và cờ tướng, đồng thời xây dựng công nghệ dùng chung và quy trình có AI hỗ trợ để một đội ngũ nhỏ có thể phát triển, vận hành và duy trì nhiều tựa game hiệu quả.',
      founder: 'Nhà sáng lập',
      founded: 'Thành lập năm',
      founderBio: 'Nhà phát triển phần mềm và game, tập trung vào game chiến thuật trên di động, cờ vua, cờ tướng và quy trình phát triển game có AI hỗ trợ.',
      statGames: 'Tựa Game Đã Phát Hành',
      statPlayers: 'Người Chơi Active',
      statUptime: 'Độ Ôn Định Server',
      statRating: 'Đánh Giá Trung Bình',
    },
    newsletter: {
      title: 'Nhận Thông Tin Mới Nhất Từ SNT Games',
      subtitle: 'Đăng ký để nhận quyền truy cập sớm, devlog phát triển và thông báo phát hành game.',
      placeholder: 'Nhập địa chỉ email của bạn...',
      subscribe: 'Đăng Ký Ngay',
      success: '🎉 Cảm ơn bạn đã đăng ký! Vui lòng kiểm tra hộp thư.',
    },
    footer: {
      desc: 'Studio game độc lập phát triển game chiến thuật trên di động và trò chơi bàn cờ, bao gồm cờ vua và cờ tướng.',
      quickLinks: 'Liên Kết Nhanh',
      contact: 'Liên Hệ Studio',
      rights: 'Bảo lưu mọi quyền.',
    },
    admin: {
      title: '🔐 Cổng Quản Trị Cấu Hình SNT Games',
      subtitle: 'Lựa chọn tựa game để tải, biên tập chỉ số và xuất bản remote config.',
      protected: '🛡️ Cloudflare Zero Trust Protected',
      loginTitle: 'Cổng Đăng Nhập Admin',
      loginDesc: 'Vui lòng đăng nhập tài khoản quản trị để tiếp tục.',
      username: 'Tài khoản (Username)',
      password: 'Mật khẩu (Password)',
      remember: 'Ghi nhớ phiên đăng nhập',
      loginBtn: '🔒 Đăng Nhập Cổng Admin',
      logoutBtn: '🔴 Đăng Xuất',
    },
  },
};
